import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "swiper-best__card" }
const _hoisted_3 = { class: "swiper-best__months" }
const _hoisted_4 = { class: "swiper-best__price" }
const _hoisted_5 = {
  key: 0,
  class: "swiper-best__text"
}
const _hoisted_6 = {
  key: 1,
  class: "swiper-best__price-month"
}
const _hoisted_7 = {
  key: 2,
  class: "swiper-best__sale"
}
const _hoisted_8 = {
  key: 3,
  class: "swiper-best__chip optimal"
}
const _hoisted_9 = {
  key: 4,
  class: "swiper-best__chip popular"
}

import { ref } from "vue";
import { Swiper, SwiperSlide } from 'swiper/vue';
import { redirectToSubscribeUrl } from "@/utils/redirects";
import TitleDefault from "@/components/TitleDefault.vue";
import type { BestPlan } from "@/types/pages/index/best-plan";
import ButtonDefault from "@/components/ButtonDefault.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'BestPlan',
  setup(__props) {

const dataPlans = ref<BestPlan[]>([
    {
        months: "1 месяц",
        price: 199,
        text: "Чтобы попробоваться",
    },
    {
        months: "3 месяца",
        price: 570,
        priceMonth: 190,
        sale: 4,
        isPopular: true,
    },
    {
        months: "6 месяцев",
        price: 1080,
        priceMonth: 180,
        sale: 4,
        isOptimal: true,
    },
    {
        months: "12 месяцев",
        price: 2076,
        priceMonth: 173,
        sale: 4,
    },
])

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TitleDefault, {
      class: "home-menu__title",
      title: "Выберите лучший тариф",
      subtitle: "Чем дольше, тем выгоднее!"
    }),
    _createVNode(_unref(Swiper), {
      "space-between": 10,
      loop: true,
      class: "swiper-best",
      "slides-per-view": "auto"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataPlans.value, (item, index) => {
          return (_openBlock(), _createBlock(_unref(SwiperSlide), { key: index }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("p", _hoisted_3, _toDisplayString(item.months), 1),
                _createElementVNode("p", _hoisted_4, _toDisplayString(item.price) + " ₽ ", 1),
                (item.text)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(item.text), 1))
                  : _createCommentVNode("", true),
                (item.priceMonth)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(item.priceMonth) + " ₽ в месяц ", 1))
                  : _createCommentVNode("", true),
                (item.sale)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_7, " Скидка ~" + _toDisplayString(item.sale) + "% ", 1))
                  : _createCommentVNode("", true),
                (item.isOptimal)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_8, " Оптимальный "))
                  : _createCommentVNode("", true),
                (item.isPopular)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_9, " Популярный "))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }),
    _createVNode(ButtonDefault, {
      class: "w-full swiper-best__button",
      label: "Попробовать за 1₽",
      onClick: _unref(redirectToSubscribeUrl)
    }, null, 8, ["onClick"])
  ]))
}
}

})